<template lang="html">
    <div class="card card-statistics">
        <div class="card-body">
            <div class="clearfix">
                <div class="float-left">
                    <i class="mdi mdi-receipt text-warning icon-lg"></i>
                </div>
                <div class="float-right">
                    <p class="mb-0 text-right">Pending Orders</p>
                    <div class="fluid-container">
                        <h3 class="font-weight-medium text-right mb-0"> {{ totalPendingOrders }} </h3>
                    </div>
                </div>
            </div>
            <p class="text-muted mt-3 mb-0">
              <i class="mdi mdi-bookmark-outline mr-1" aria-hidden="true"></i>  </p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from'vuex'
export default {
  name: 'totalpendingorderscard',
  computed : {
      ...mapGetters({
          totalPendingOrders : 'ordermessages/totalPendingOrders',
      })
  }
}
</script>